import React, { useEffect, useMemo, useState } from 'react'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import LtsJsonEditorDialog from './lts-json-editor-dialog'
import storage from '../../services/stoage.service'
import utils from '../../utils'
import './lts-json-area.scss'

export default function LtsJsonArea(props) {
  const {
    value,
    onChange: onChangeProp,
    label,
    hidden,
    disabled,
    name,
    rows = 10,
    cols,
    modalTitle,
    modalWidth,
    renderForm,
    validate,
  } = props

  const [jsonString, setJsonString] = useState('')
  const [error, setError] = useState(null)
  const [showModal, setShowModal] = useState(false)
  // getAppLabels devolve objeto novo a cada chamada — memoizado para não disparar o effect a cada render
  const messages = useMemo(() => storage.getAppLabels('lts'), [])

  useEffect(() => {
    if (value && typeof value === 'object') {
      try {
        const serializado = JSON.stringify(value)
        setJsonString((atual) => {
          // texto atual já representa o mesmo objeto (ex.: o onChange acabou de emitir o parse
          // dele) — mantém a formatação/cursor do usuário em vez de reformatar
          try {
            if (atual && JSON.stringify(JSON.parse(atual)) === serializado) {
              return atual
            }
          } catch (e) {
            // texto atual inválido: substitui pela versão do value
          }
          return JSON.stringify(value, null, 2)
        })
        setError(null)
      } catch (err) {
        setJsonString('')
        setError(utils.getMessage(messages, 'lts.label.jsonarea.error.converterobject'))
      }
    } else if (typeof value === 'string') {
      setJsonString(value)
    } else {
      setJsonString('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const onChange = (event) => {
    const newValue = event.target.value
    setJsonString(newValue)

    if (!newValue || newValue.trim() === '') {
      setError(null)
      onChangeProp?.({})
      return
    }

    try {
      const parsed = JSON.parse(newValue)
      setError(null)
      onChangeProp?.(parsed)
    } catch (err) {
      setError(utils.getMessage(messages, 'lts.label.jsonarea.error.jsoninvalido'))
    }
  }

  return (
    <div className="lts-json-area">
      <div className="json-area-header">
        {!disabled && (
          <Button
            label={utils.getMessage(messages, 'lts.label.jsonarea.button.edicaovisual')}
            icon="pi pi-pencil"
            className="p-button-sm p-button-outlined"
            onClick={() => setShowModal(true)}
          />
        )}
      </div>
      <span className="p-float-label">
        <InputTextarea
          value={jsonString}
          onChange={onChange}
          name={name}
          rows={rows}
          cols={cols ?? 30}
          autoResize={false}
          disabled={disabled}
          className={error ? 'p-invalid' : ''}
          style={{
            fontFamily: "'Courier New', Courier, monospace",
            fontSize: '14px',
          }}
        />
        {label && !hidden && <label>{label}</label>}
      </span>
      {error && <small className="p-error">{error}</small>}

      <LtsJsonEditorDialog
        visible={showModal}
        value={value}
        title={modalTitle || utils.getMessage(messages, 'lts.label.jsonarea.modal.title')}
        labelConfirmar={utils.getMessage(messages, 'lts.label.jsonarea.modal.button.confirmar')}
        width={modalWidth}
        onHide={() => setShowModal(false)}
        onConfirm={(data) => onChangeProp?.(data)}
        renderForm={renderForm}
        validate={validate}
      />
    </div>
  )
}
